import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-warranty',
  templateUrl: './dialog-warranty.component.html',
  styleUrls: ['./dialog-warranty.component.scss'],
})
export class DialogWarrantyComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
